<template>
    <v-container>
        <template>
            <v-card class="test-camera" style="border-radius: 15px;">
                <v-container-fluid>
                    <v-layout row wrap px-4 py-4>
                        <v-flex xs12 sm12 md12>
                            <v-avatar color="primary-bg-light-1" size="100" style="margin-left:auto; margin-right:auto; display:block">
                                <!-- <v-icon dark style="font-size:52pt">photo_camera</v-icon> -->
                                <i class="mdi mdi-camera"></i>
                            </v-avatar>  
                        </v-flex>
                        <v-flex xs12 sm12 md12 my-3>
                            <center>
                                <div><h3 class="grey--text text--darken-2" >
                                    Camera Settings Test
                                </h3></div>
                                <p class="grey--text text--darken-2 mb-0 mt-1" >
                                    1. Please <b> allow camera access.</b>
                                </p>
                                <p class="grey--text text--darken-2 mb-0 mt-1">
                                    2. Please allow <b> MediaRecorder</b>
                                    option in Safari Advanced settings.
                                </p>
                                
                            </center>
                        </v-flex>
                        <v-flex xs12 sm12 md12 >
                            <v-layout row style="text-align: -webkit-center;">
                                <v-flex>
                                    <v-btn color="primary-btn" style="width: max-content;" dark block class="text-none" id="starttest"  @click="testcamereaclick()">Test Camera</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container-fluid>
            </v-card>
        </template>
    </v-container>
</template>

<script>
import router from '@/router';
import { db } from '@/sunidhiapp';
// import axios from 'axios';


export default {
  name: 'liveness_landingPage',
  mounted: async function () {
            this.$sunidhi.logoutBtnDisp = true;
            var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
            if (genzdata != null || genzdata.length > 0) {
                if (typeof genzdata[0].token == 'undefined') {
                    this.userid = '0';
                }
                else {
                    this.userid = genzdata[0].token;
                }
            }
            else {
                this.userid = '0';
            }

             
            
        },
        methods: {
            testcamereaclick() {
                this.$sunidhi.logoutBtnDisp = true;
               router.push({ name: "livenessCheck", params: { userid: this.$route.params.userid } });
            }
        }
}
</script>

<style scoped>

.primary-bg-light-1 {
    /* background-color: #003983 !important; */
}

i {
    font-size: 75px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -47%);
    color: #fff;
}

@media screen and (max-width:1280px) {
    .test-camera {
        border-radius: 15px;
        position: absolute;
        width: 75%;
        padding: 20px;
        line-height: 2em;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
    

</style>
